export const toolTipMessagesEmbroy = {
  Rating: `Add a rating, such as “Excellent” or “Average”, to characterize one or more grades.`,
  Grade: `Add one or more grades, such as “3AA” or “abnormal”. Click Enter to add.`,
};
export const toolTipMessagesOocyte = {
  Rating: `Add a rating such as “Mature” or “Immature” to characterize oocyte maturity levels.`,
  Grade: `Add one or more maturity levels, such as “MI” or “MII”. Click Enter to add.`,
};
